import { IframeHTMLAttributes } from 'react';

const Scrolling = {
  Yes: 'yes',
  No: 'no',
  Auto: 'auto',
} as const;

type ScrollingType = typeof Scrolling[keyof typeof Scrolling];

export default interface IFrameProps extends IframeHTMLAttributes<HTMLIFrameElement> {
  url: string;
  sandbox: string;
  scrolling?: ScrollingType;
  height?: number;
  dataCy?: string;
  dataTestid?: string;
}
export { Scrolling };
